import { create } from "zustand"
import { persist } from "zustand/middleware"

/** One thing the visitor searched for: which source and which tags. Kept on this device only. */
export interface RecentBrowse {
  site: string
  tags: string[]
  at: number
}

// The welcome panel pages recents 2 at a time, up to 3 pages.
export const MAX_RECENT_BROWSES = 6

interface RecentBrowseState {
  recents: RecentBrowse[]
  record: (site: string, tags: string[]) => void
  clear: () => void
}

const sameSearch = (a: RecentBrowse, site: string, tags: string[]) => a.site === site && a.tags.join(",") === tags.join(",")

export const useRecentBrowseStore = create<RecentBrowseState>()(
  persist(
    (set, get) => ({
      recents: [],
      record: (site, tags) => {
        if (!site || tags.length === 0) return
        const rest = get().recents.filter((r) => !sameSearch(r, site, tags))
        set({ recents: [{ site, tags, at: Date.now() }, ...rest].slice(0, MAX_RECENT_BROWSES) })
      },
      clear: () => set({ recents: [] }),
    }),
    { name: "recent-browses" },
  ),
)
